import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/imgs/customer-bg.png';
import _imports_1 from '@/assets/imgs/customer-icon.png';
import _imports_2 from '@/assets/imgs/wechat_ewm6.png';
import _imports_3 from '@/assets/imgs/phone-icon.png';
const _hoisted_1 = {
  class: "advisory-service"
};
const _hoisted_2 = {
  class: "customer-box"
};
const _hoisted_3 = {
  class: "customer-info"
};
const _hoisted_4 = {
  class: "custom-header"
};
const _hoisted_5 = {
  class: "exclusive-info"
};
const _hoisted_6 = {
  class: "custom-ewm-box"
};
const _hoisted_7 = {
  class: "slogan-txt"
};
const _hoisted_8 = {
  class: "hotline"
};
const _hoisted_9 = {
  class: "phone-number"
};
import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    const visible = ref(false);
    const hide = () => {
      visible['value'] = false;
    };
    const show = () => {
      visible['value'] = true;
    };
    __expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => visible.value = $event),
        width: "690"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("img", {
          class: "left-img",
          src: _imports_0
        }, null, -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[1] || (_cache[1] = _createElementVNode("img", {
          class: "customer-icon",
          src: _imports_1
        }, null, -1)), _createElementVNode("div", _hoisted_5, [_createElementVNode("h3", null, _toDisplayString(_ctx.$t('home.only_customer')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('home.free_quote')), 1)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('home.good_quote')), 1), _cache[3] || (_cache[3] = _createElementVNode("div", {
          class: "custom-ewm"
        }, [_createElementVNode("img", {
          src: _imports_2
        })], -1)), _createElementVNode("div", _hoisted_8, [_cache[2] || (_cache[2] = _createElementVNode("img", {
          class: "hotline-icon",
          src: _imports_3
        }, null, -1)), _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('home.phone')) + "：199-8206-5680", 1)]), _cache[4] || (_cache[4] = _createElementVNode("p", {
          class: "phone-number",
          style: {
            "margin-top": "2px"
          }
        }, "企业QQ：2851655063", -1))])])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});